import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  const commonTextStyles = css`
    font-family: FS Dillon;
    text-align: left;
  `;
  return {
    CFAContactCountyBNRCont: css`
      display: flex;
      padding-top: 2rem;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.625rem;
      align-self: stretch;
    `,
    CFABannerText: css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
    `,
    CFACCTitle: css`
      ${commonTextStyles};
      color: ${colors.navy};
      font-weight: 700;
      font-size: 1.35rem;
      line-height: 1.5rem;
      font-style: italic;
      letter-spacing: 0.0014rem;
      padding-left: 0.75rem;
    `,
    CFACCSubTitle: css`
      ${commonTextStyles};
      color: ${colors.darkGrey};
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5rem;
      letter-spacing: 0.0225rem;
      padding-left: 0.75rem;
    `,
    CFACCButton: css`
      color: ${colors.darkGrey};
      &:hover {
        font-weight: 700;
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
        }
      }
    `,
  };
};
